import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment'
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { CacheService } from 'mapfre-auditlib';

@Injectable({
  providedIn: 'root'
})
export class ExportConfigService {

  className = 'ExportConfigService';

  constructor(private http: HttpClient, private cacheService: CacheService) { }

  getExportConfig() {
    return this.http.get("./assets/mocks/EXPORT_CONFIG.json").pipe(map<any[], any[]>(res => res['export-config']));
  }

  setFiltersConfig(data): Observable<any[]> {
    return this.http.post<any[]>(environment.base_URL + "/user-config", data);
  }

  getFiltersConfig(type, cache=true, cacheKey = "filtersConfig") {
    const params = {
      type
    }
    cacheKey = cacheKey+"_"+type.toString()
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      let observable = this.http.get(environment.base_URL + "/user-config", { params }).pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  getFiltersMappingFile() {
    return this.http.get('./assets/mocks/FILTERS_MAPPING.json');
  }

  getFiltersStructure(key) {
    return Observable.create((observer) => {
      this.getFiltersMappingFile().subscribe((data) => {
        observer.next(data[key]);
        observer.complete();
      });
    });

  }

  removeById(array) {
    array.forEach(element => {
      delete element.id;
    });
    return array;
  }

  getExcelMappingFile() {
    return this.http.get('./assets/mocks/EXCEL_MAPPING.json');
  }

  getExcelData(key) {
    return Observable.create((observer) => {
      this.getExcelMappingFile().subscribe((data) => {
        observer.next(data[key]);
        observer.complete();
      });
    });

  }
}